(function () {
    'ngInject';

    angular.module('app.shared.services').factory('RemoveBgAPIService', removeBgAPIService);

    function removeBgAPIService() {
        const baseURL = 'https://api.remove.bg/v1.0';

        async function isValidAPIKey(key) {
            const config = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'X-Api-Key': key,
                    cache: 'no-store'
                }
            };

            try {
                const response = await fetch(baseURL + '/account', config);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.json();
            } catch (error) {
                throw error;
            }
        }

        async function removeBackground(key, image) {
            const formData = new FormData();
            formData.append('image_file', image);

            try {
                const response = await fetch(baseURL + '/removebg', {
                    method: 'POST',
                    headers: { 'X-Api-Key': key },
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.blob();
            } catch (error) {
                throw error;
            }
        }

        return { isValidAPIKey, removeBackground };
    }
})();
